import { useState } from 'react'
import { MemberBookingWizard } from '../MemberBookingWizard/MemberBookingWizard'
import { getMembershipExtendedColors } from '../common/membershipStyles'
import { MemberProfileExtendedType, VALID_PEOPLE_ENTITIES } from 'common/types/MemberProfile'
import { useNavigate } from 'react-router-dom'

interface ProfileCTAButtonProps {
  profile: MemberProfileExtendedType
  className?: string
}

export function ProfileCTAButton({
  className,
  profile,
}: ProfileCTAButtonProps) {
  const [isBookingWizardOpen, setIsBookingWizardOpen] = useState(false)
  const colors = getMembershipExtendedColors(profile?.metadata.membership_type)
  const navigate = useNavigate()

  const handleCTAClick = () => {
    if (VALID_PEOPLE_ENTITIES.includes(profile?.memberEntity)) {
      setIsBookingWizardOpen(true)
    } else {
      navigate('/find-a-lawyer/team', { state: { profile } })
    }
  }

  return (
    <>
      <button
        onClick={handleCTAClick}
        className={`${className} ${colors.buttonBg.default} ${colors.buttonBg.hover} text-sm text-[#f4f4f4] rounded-md ml-4 shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)]`}
      >
        Connect
      </button>
      <MemberBookingWizard
        profile={profile}
        isOpen={isBookingWizardOpen}
        handleClose={() => setIsBookingWizardOpen(false)}
      />
    </>
  )
}
